import { useSelector } from 'react-redux'
import defaultAvatar from '@/(front-desk)/assets/images/default-avatar.png'

export default function UserAvatar(props) {

    const global = useSelector((state) => state.global)

    return (
        <>
        <div className="avatar">
            { props.avatar
                ?
                <img src={props.avatar} alt="使用者頭像" />
                :
                <div className={`color color-${global.color}`}>
                    { props.screenName
                        ? <div className="letter">{props.screenName.slice(0, 1)}</div>
                        : <img src={defaultAvatar.src} alt="使用者預設頭像" />
                    }
                </div>
            }
        </div>
        </>
    )
}